import React from "react";
import { MdDelete } from "react-icons/md";


function MenuItemCard({
    item,
    category,
    uniqueKey,
    isSelected,
    quantity,
    toggleSelectionQuantity,
    adjustQuantity,
    getMenuIconConfig,
    setSelectedDish
}) {

    const { bg, icon: Icon } = getMenuIconConfig(item);

    return (
        <div
            className={`relative rounded-xl overflow-hidden group transition-all duration-300 ${isSelected
                    ? "ring-2 ring-amber-500 shadow-amber-200 shadow-lg"
                    : "shadow-md hover:shadow-xl"
                }`}
        >
            <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-gray-100"></div>


            <div className="absolute top-2 right-2 z-10">
                {(() => {
                    const { bg, icon: Icon } = getMenuIconConfig(item);
                    return (
                        <span className={`inline-flex items-center justify-center h-5 w-5 rounded-full ${bg}`}>
                            <Icon className="text-white text-xs" />
                        </span>
                    );
                })()}
            </div>

            <div key={item["Item Name"]} data-item-name={encodeURIComponent(item["Item Name"])} className="group relative bg-white rounded-3xl p-3 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 flex gap-4 transition-all duration-300 hover:shadow-xl hover:border-gray-200">

                {/* --- LEFT: Image Section --- */}
                <div className="relative shrink-0">
                    <div
                        className="w-32 h-32 rounded-2xl overflow-hidden bg-gray-50 shadow-inner cursor-pointer"
                        onClick={() =>
                            setSelectedDish({
                                name: item["Item Name"],
                                description: item["Item Description"],
                                image: item.imageUrl,
                                price: item["Price"],
                            })
                        }
                    >
                        {item.imageUrl ? (
                            <img
                                src={item.imageUrl}
                                loading="lazy"
                                decoding="async"
                                alt={item["Item Name"]}
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                        ) : (
                            <div className="w-full h-full flex flex-col items-center justify-center text-gray-300 bg-gray-50">
                                <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                                <span className="text-[10px] font-medium">No Image</span>
                            </div>
                        )}
                    </div>

                    {/* Jain Badge - Glassmorphism Style */}
                    {item["Level 2"] === "Jain" && (
                        <span className="absolute top-2 left-2 px-2 py-1 bg-white/90 border border-white/50 text-emerald-700 text-[10px] font-bold tracking-wide uppercase rounded-lg shadow-sm">
                            Jain
                        </span>
                    )}
                </div>

                {/* --- RIGHT: Content Section --- */}
                <div className="flex-1 flex flex-col justify-between py-1">

                    {/* Top: Name & Desc */}
                    <div className="space-y-1">
                        <div className="flex justify-between items-start gap-2">
                            <h4 className="text-base font-bold text-gray-900 leading-tight tracking-tight line-clamp-2">
                                {item["Item Name"]}
                            </h4>
                        </div>

                        <div
                            className="text-xs text-gray-500 line-clamp-2 leading-relaxed font-medium"
                            dangerouslySetInnerHTML={{
                                __html: item["Item Description"] || "",
                            }}
                        />
                    </div>

                    {/* Bottom: Price & Actions */}
                    <div className="mt-3 flex items-end justify-between">

                        {/* Price Display */}
                        <div className="flex flex-col">
                            <span className="text-lg font-extrabold text-gray-900">
                                ₹{item["Price"]}
                            </span>
                        </div>

                        {/* Action Buttons */}
                        <div className="relative z-10">
                            {isSelected ? (
                                /* Quantity Control - Premium Capsule */
                                <div className="flex items-center bg-white rounded-full border border-gray-200 shadow-sm p-1 gap-1">

                                    {/* Decrease */}
                                    {quantity === 1 ? (
                                        <button
                                            onClick={() => toggleSelectionQuantity(uniqueKey)}
                                            className="w-8 h-8 flex items-center justify-center rounded-full bg-red-50 text-red-500 hover:bg-red-100 transition-colors"
                                        >
                                            <MdDelete size={16} />
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => adjustQuantity(uniqueKey, -1)}
                                            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-600 font-bold transition-colors"
                                        >
                                            −
                                        </button>
                                    )}

                                    <span className="w-6 text-center text-sm font-bold text-gray-900">
                                        {quantity}
                                    </span>

                                    {/* Increase */}
                                    <button
                                        onClick={() => adjustQuantity(uniqueKey, 1)}
                                        className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-900 text-white hover:bg-gray-800 shadow-md transition-all active:scale-90"
                                    >
                                        +
                                    </button>
                                </div>
                            ) : (
                                /* Initial Add Button - High Contrast */
                                <button
                                    onClick={() => toggleSelectionQuantity(uniqueKey)}
                                    className="px-6 py-2.5 rounded-xl bg-gray-900 text-white text-xs font-bold tracking-wider uppercase shadow-lg shadow-gray-200 hover:bg-gray-800 hover:shadow-gray-300 active:scale-95 transition-all duration-200"
                                >
                                    Add +
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default React.memo(MenuItemCard);
